import { takeLatest, call, put } from "redux-saga/effects";
import {
  ENGINEER_PAGE_LOAD,
  engineerPageLoaded,
} from "../../actions/engineers";
import listRegions from "../../../../../backend/oncall/partners/regions/list";
import getEngineer from "../../../../../backend/oncall/partners/engineers/get-by-id";
import { regionsLoaded } from "../../actions/regions";
import { showErrorPage } from "../../../../../actions/ui/location";

const engineerPageLoadSaga = function*(action) {
  try {
    const regionsResult = yield call(listRegions);
    yield put(regionsLoaded(regionsResult.regions));
    if (action.payload.engineerId === undefined) {
      // These are the default values on the add page.
      yield put(
        engineerPageLoaded({
          firstName: "",
          lastName: "",
          workPhone: "",
          workPhonePriority: "-1",
          cellPhone: "",
          cellPhonePriority: "-1",
          homePhone: "",
          homePhonePriority: "-1",
          regionId: "-1",
          enabled: true,
          emails: [],
        }),
      );
      return;
    }
    const result = yield call(getEngineer, action.payload.engineerId);
    yield put(engineerPageLoaded(result));
  } catch (ignore) {
    yield put(showErrorPage());
  }
};

export default function*() {
  //noinspection JSCheckFunctionSignatures
  yield takeLatest(ENGINEER_PAGE_LOAD, engineerPageLoadSaga);
}



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/sagas/engineers/edit-page-load.js